/**
 * @bref    Fonctionnalitées jQuery relatives au Menu.
 * @remark  Fichier appelé dans un bloc jQuery.
 */
require('../functions/AppAjax.class');
let AppAjax = window.AppAjax;

//#####################################################
// BURGER MENU
//#####################################################
$('.burger-menu').click(function(event) {
    event.stopPropagation();
    $('.main-menu').toggleClass('active');
    $('.top-info-menu').toggleClass('active');
});

$('.burger-menu').click(function(event) {
    event.stopPropagation();
    $(this).toggleClass('open');
});

//#####################################################
// DROPDOWN MENU
//#####################################################
var userLink = $('.has-sub span');

userLink.each(function() {
    $(this).on('click', function(event) {
        event.stopPropagation();
        var submenu = $(event.currentTarget).next();
        submenu.toggleClass('open');

        var topMenuLink = $(event.currentTarget).closest('.has-sub');
        if (topMenuLink) {
            topMenuLink.toggleClass('active');
        }
    });
});

$(document).on('click', function(event) {
    event.stopPropagation();
    var target = $(event.target);
    if (!target.closest('.sub-menu').length) {
        $('.sub-menu').removeClass('open');
    }
});
